angular.module( 'app.utilsService', [

])

.factory( 'utilsService', ['$filter', '$compile', '$templateCache', '$timeout',  function ( $filter, $compile, $templateCache, $timeout ) {
    return {
        reporteTabla: function(columns, rows, orientacion, tamanio, titulo) {
            if (orientacion == 'p') {
                value = 400;
            } else {
                value = 850;
            }
            var doc = new jsPDF(orientacion, 'pt', tamanio);
            var totalPagesExp = "{total_pages_count_string}";
            var fecha_hora = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
            //var imgData = 'data:image/png;base64,'+ btoa('img/logo.png');
            var header = function (data) {
                // header
                //doc.addImage(imgData, 'PNG', 15, 40, 180, 160);
                doc.setFontSize(14);
                doc.setTextColor(40);
                doc.setFontStyle('normal');
                doc.text(titulo, data.settings.margin.left + 45, 35);
                doc.setFontSize(7);
                doc.text("Dogmapp", data.settings.margin.left + 45, 45);
                doc.text("Fecha de Reporte: " + fecha_hora, data.settings.margin.left + 650, 45);
                // footer
                var str = "Página " + data.pageCount;
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp;
                }
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            };
            var options = {
                theme: 'striped',
                addPageContent: header,
                margin: {
                    top: 55,
                    left: 5,
                    right: 5,
                    button: 10
                },
                styles: {
                    overflow: 'linebreak',
                    font: 'times',
                    fontSize: 9,
                    cellPadding: 8
                },
                headerStyles: {
                    overflow: 'linebreak',
                    font: 'times',
                    fontSize: 8,
                    cellPadding: 8
                }
            };
            doc.autoTable(columns, rows, options);
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }
            return doc.output('datauristring');
        },
        reportesCitas: function (data, estado) {
            var body = [];
            var columns = [
                { text: 'ID', style: 'tableHeader' },
                { text: 'Medico/Institucion', style: 'tableHeader' },
                { text: 'Especialidad', style: 'tableHeader' },
                { text: 'Fecha', style: 'tableHeader' },
                { text: 'Hora', style: 'tableHeader' },
                { text: 'Visitador', style: 'tableHeader' },
                { text: 'Producto', style: 'tableHeader' },
                { text: 'Cantidad', style: 'tableHeader' },
                { text: 'Observaciones', style: 'tableHeader' }
            ];

            var titulo = 'visitas completadas';

            if (estado) {
                if (estado == 1)
                    titulo = 'visitas programadas';
                if (estado == 2)
                    titulo = 'visitas no completadas';
                if (estado == 3)
                    titulo = 'visitas completadas';
                if (estado == 4)
                    titulo = 'visitas canceladas';
            }
            
            //Totales
            var tColumn = [{ text: 'Descripción', style: 'tableHeader' },
                { text: 'Total', style: 'tableHeader' }];
            var totales = [];
            totales.push(tColumn);
            var tRow = [{text:'Médicos'}, {text:data.mCount}];
            totales.push(tRow);
            tRow = [{ text: 'Instituciones' }, { text: data.iCount }];
            totales.push(tRow);
            //

            body.push(columns);
            data.visitas.forEach(function (item) {
                var rowspan = 0;
                var producto = '';
                var cantidad = '';
                if (item.medicamentos) {

                    if (item.medicamentos[0]) {

                        producto = item.medicamentos[0].producto;
                        cantidad = item.medicamentos[0].cantidad;

                    }

                    rowspan = item.medicamentos.length;
                }

                
                var row = [
                    {
                        rowSpan: rowspan,
                        text: item.citaId
                    },
                    {
                        rowSpan: rowspan,
                        text: item.medico !=null ? item.medico.nombre : item.institucion
                    },
                    {
                        rowSpan: rowspan,
                        text: item.medico != null ? item.medico.especialidad: ''
                    },
                    {
                        rowSpan: rowspan,
                        text: item.citaFecha
                    },
                    {
                        rowSpan: rowspan,
                        text: item.citaHora
                    },
                    {
                        rowSpan: rowspan,
                        text: item.visitador
                    },
                    producto,
                    cantidad,
                    {
                        rowSpan: rowspan,
                        text: item.observaciones !=null ? item.observaciones : ''
                    }
                   
                ]
                body.push(row);
                for (i = 1; i < rowspan; i++) {

                    var prod = '';
                    var cant = '';

                    if (item.medicamentos[i]) {
                        prod = item.medicamentos[i].producto;
                        cant = item.medicamentos[i].cantidad;
                    }

                    row = [
                        '','','','','','',
                        prod,
                        cant, ''
                    ]
                    body.push(row);
                }
            });
            var docDefinition = {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [30, 30, 30, 30],
                content: [
                    {
                        columns: [
                            {
                                width: 'auto',
                                stack: [
                                    {
                                        image: 'data:image/jpeg;base64,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'
                                    }
                                ]
                            },
                            {
                                width: '*',
                                alignment: 'center',
                                stack: [
                                    {
                                        style: 'h1',
                                        text: 'Reporte de ' + titulo
                                    }
                                ]
                            }
                        ]
                    }, ' ',
                    {
                        style: 'tableStyle',
                        table: {
                            widths: ['10%', '5%'],
                            headerRows: 1,
                            body: totales
                        },
                        layout: 'lightHorizontalLines'
                    },
                    {
                        style: 'tableStyle',
                        table: {
                            widths: [ '5%', '20%', '10%', '9%', '8%','10%','10%','7%','21%' ],
                            headerRows: 1,
                            body: body
                        },
                        layout: 'lightHorizontalLines'
                    }
                ],
                styles: {
                            tableStyle: {
                                fontSize: 10,
                                color: '#000000',
                                fillColor: '#D8D8D8',
                                margin: [0, 15, 0, 5]
                            },
                            h1: {
                                margin: [0, 5, 0, 0],
                                fontSize: 20,
                                bold: true
                            },
                            tableHeader: {
                                fillColor: '#76C6B9',
                                color: 'white',
                                bold: true
                            }
                        },
               
                footer: function(currentPage, pageCount) { 
                    return { 
                        columns: [ 
                            { 
                                alignment: 'right',
                                text: 'Página No.' + currentPage.toString() + ' de ' + pageCount
                            }
                        ],
                        margin: [30, 0]
                    };
                },
            };
            // Ad blocker deshabilitado y pop ups habilitadas para el sitio. 
            pdfMake.createPdf(docDefinition).open();
        },
        reporteUniversos: function(data, tipo){
            var body = [];
            var titulo = '';
            var widths = [];

            if (tipo == 'medico') {
                titulo = 'Universo médico';
                var columns = [
                    {text: 'ID', style: 'tableHeader'},
                   { text: 'Nombre', style: 'tableHeader' },
                   { text: 'Especialidad', style: 'tableHeader' },
                   { text: 'Dirección', style: 'tableHeader' },
                   { text: 'Sector', style: 'tableHeader' },
                   { text: 'Ciudad', style: 'tableHeader' }
                ];
                body.push(columns);
                widths = ['5%', '30%', '10%', '30%', '10%', '15%'];
                data.forEach(function (medico) {

                    var row = [
                        { text: medico.medicoId},
                        { text: medico.nombre },
                        { text: medico.especialidad },
                        { text: medico.consultorios[0].direccion },
                        { text: medico.sector },
                        { text: medico.ciudad }
                    ];

                    body.push(row);
                });
            } else if (tipo == 'institucion') {
                widths = ['5%','30%', '40%', '10%', '15%'];
                titulo = 'Universo de Instituciones';
                var columns = [
                    {text: 'ID', style: 'tableHeader'},
                   { text: 'Nombre', style: 'tableHeader' },
                   { text: 'Dirección', style: 'tableHeader' },
                   { text: 'Sector', style: 'tableHeader' },
                   { text: 'Ciudad', style: 'tableHeader' }
                ];
                body.push(columns);

                data.forEach(function (institucion) {

                    var row = [
                        { text: institucion.institucionId},
                        { text: institucion.nombre },
                        { text: institucion.direccion },
                        { text: institucion.sector },
                        { text: institucion.ciudad }
                    ];

                    body.push(row);
                });
            }

            var docDefinition = {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [30, 30, 30, 30],
                content: [
                    {
                        columns: [
                            {
                                width: '*',
                                alignment: 'center',
                                stack: [
                                    {
                                        style: 'h1',
                                        text: titulo
                                    }
                                ]
                            }
                        ]
                    }, ' ',
                    {
                        style: 'tableStyle',
                        table: {
                            widths: widths,
                            headerRows: 1,
                            body: body
                        },
                        layout: 'lightHorizontalLines'
                    }
                ],
                styles: {
                    tableStyle: {
                        fontSize: 10,
                        color: '#000000',
                        fillColor: '#D8D8D8',
                        margin: [0, 15, 0, 5]
                    },
                    h1: {
                        margin: [0, 5, 0, 0],
                        fontSize: 20,
                        bold: true
                    },
                    tableHeader: {
                        fillColor: '#76C6B9',
                        color: 'white',
                        bold: true
                    }
                },

                footer: function (currentPage, pageCount) {
                    return {
                        columns: [
                            {
                                alignment: 'right',
                                text: 'Página No.' + currentPage.toString() + ' de ' + pageCount
                            }
                        ],
                        margin: [30, 0]
                    };
                },
            };
            // Ad blocker deshabilitado y pop ups habilitadas para el sitio. 
            pdfMake.createPdf(docDefinition).open();
        }
  };
}]);